import {PaymentItemForView} from './PaymentItemForView'
import {PAYMENT_TYPE} from '../../../CodeMaster'

export class PaymentItemForViewOption extends PaymentItemForView {
    private readonly quantity: number
    private readonly unitName: string

    constructor(
        id: number,
        article: string,
        paymentType: PAYMENT_TYPE,
        charge: number,
        quantity: number,
        unit: string,
        displayOrder: number,
    ) {
        super(id, article, paymentType, charge, displayOrder)
        this.quantity = quantity
        this.unitName = unit
    }

    quantityWithUnit(): string {
        return `${this.quantity}${this.unitName}`
    }
}
